import React from 'react';
import PropTypes from 'prop-types';
import Griddle, { plugins, RowDefinition, ColumnDefinition } from 'griddle-react';
import {
  ButtonGroup,
  Button,
} from 'react-bootstrap';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';


const styleConfig = {
  icons: {
    TableHeadingCell: {
      sortDescendingIcon: '▼',
      sortAscendingIcon: '▲',
    },
  },
  classNames: {
    Row: 'row-class',
    Table: 'table-striped table',
    Filter: 'hide-element',
  },
  styles: {
    Filter: { fontSize: 18 },
  },
};

function findById(value) {
  console.log('findById ', value.id, this);
  return value.id === Number(this);
}

const rowDataSelector = (state, { griddleKey }) => {
  return state
    .get('data')
    .find(rowMap => rowMap.get('griddleKey') === griddleKey)
    .toJSON();
};

const enhancedWithRowData = connect((state, props) => {
  return {
    rowData: rowDataSelector(state, props)
  };
});

function truncate(str, n){
  return (str.length > n) ? str.substr(0, n-1) + '...': str;
};


class SearchHotelListTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    
    };
    this.onUserClick = this.onUserClick.bind(this);
  }

  onUserClick = (e) => {
    const id = e.currentTarget.getAttribute('data-item');
    browserHistory.push(`/hotels/users/${id}`);
  }

  onViewClick = (e) => {
    const id = e.currentTarget.getAttribute('data-item');
    this.props.viewHotel(id);
  }

  render() {
    let hotelsList = [];
    this.props.hotels.forEach((hotel)=>{
      hotelsList.push({
        id: hotel.id,
        name: hotel.name,
        address: hotel.address,
        stars: hotel.stars,
        issubscriber: hotel.is_subscriber_hotel
      })

    })

    const partnerHotelFormatter = (row) => {
      const rowData = row.rowData;
      let hotelName = truncate(rowData.name, 23);
      if(rowData.issubscriber) {
        return (
        <span title={rowData.name} style={{color: 'green'}}> {hotelName} </span>
       )
      }
      return (
        <span title={rowData.name}> {hotelName} </span>
      )
    }

    const addressFormatter = (row) => {
      const rowData = row.rowData;
      if(rowData.issubscriber) {
        return (
        <span style={{color: 'green'}}> {rowData.address} </span>
       )
      }
      return (
        <span> {rowData.address} </span>
      )
    }

    const starsFormatter = (row) => {
      const rowData = row.rowData;
      if(rowData.issubscriber) {
        return (
        <span style={{color: 'green'}}> {rowData.stars} </span>
       )
      }
      return (
        <span> {rowData.stars} </span>
      )
    }

    const ButtonColumn = ({ value }) => (
      <ButtonGroup className="hotel-list-view-edit-btn-grp">
        <Button data-item={value} onClick={this.onViewClick} bsStyle="success">
          View
        </Button>
        <Button className="hotel-list-users-btn" data-item={value} onClick={this.onUserClick} bsStyle="success">
          Users
        </Button>
      </ButtonGroup>
      );
    return (
      <div>
        {hotelsList.length > 0 && (<Griddle
              data={hotelsList}
              styleConfig={styleConfig}
              plugins={[plugins.LocalPlugin]}
              pageProperties={{
                currentPage: 1,
                pageSize: 30
              }}
              components={{
                SettingsToggle: () => <span />,
              }}
              >
            <RowDefinition>
              <ColumnDefinition id="name" order={1} title="Hotel" customComponent={enhancedWithRowData(partnerHotelFormatter)}/>
              <ColumnDefinition id="address" order={2} title="Address" customComponent={enhancedWithRowData(addressFormatter)}/>
              <ColumnDefinition id="stars" order={3} title="Stars" customComponent={enhancedWithRowData(starsFormatter)}/>
              <ColumnDefinition id="issubscriber" order={5} title="" visible={false}/>
              <ColumnDefinition id="id" title=" " customComponent={ButtonColumn} />
            </RowDefinition>
          </Griddle>)}
      </div>
    );
  }
}


SearchHotelListTable.propTypes = {
  hotel: PropTypes.object.isRequired,
  viewHotel: PropTypes.func.isRequired,
  requestHotelClaim: PropTypes.func.isRequired,
};

export default SearchHotelListTable;



// WEBPACK FOOTER //
// src/routes/hotels/components/SearchHotelListTable.js